import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { useEffect, useState } from "react";
import isMobile from "ismobilejs";
import * as React from "react";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";
import useLaunchDarklyFlags from "@MasterBluePrint/Common/Hooks/useLaunchDarklyFlags";

export interface VerticalDelimiterStyle {
  flexContainer?: InjectableCss;
  topBottomDiv?: InjectableCss;
  middleDiv?: InjectableCss;
  lineDiv?: InjectableCss;
}

const verticalDelimiterStyles: VerticalDelimiterStyle = {
  flexContainer: {
    css: css`
      display: flex;
      align-items: center;
      height: 100%;
      flex-direction: column;
    `,
  },
  topBottomDiv: {
    css: css`
        flex-grow: 1;
        margin: 10px;
    `
  },
  middleDiv: {
    css: css`
    display: flex;
    font-size: 32px;
    font-family: Lato;
    font-weight: bold;
    color: #002554;
    `
  },
  lineDiv: {
    css: css`
        border-left: 2px solid #C2D1D9;
        height: 100%;
    `
  },
}
const featureFlags: string[] = ["TEUS-7947"];

export const VerticalDelimiter = () => {
  const [isMobileBrowser, setIsMobileBrowser] = useState(false);

  const flagValues = useLaunchDarklyFlags({ featureFlags });
  const showVerticalDelimiter = flagValues["TEUS-7947"];

  useEffect(() => {
    setIsMobileBrowser(isMobile().any);
    window.addEventListener("resize", () => {
      window.setTimeout(() => {
        setIsMobileBrowser(isMobile().any)
      }, 50);
    });

    return () => {
      window.removeEventListener("resize", () => {
        window.setTimeout(() => {
          setIsMobileBrowser(isMobile().any)
        }, 50);
      });
    };
  }, []);

  return ((showVerticalDelimiter && !isMobileBrowser) ?
    <>
      <StyledWrapper {...verticalDelimiterStyles.flexContainer}>
        <StyledWrapper {...verticalDelimiterStyles.topBottomDiv}>
          <StyledWrapper {...verticalDelimiterStyles.lineDiv}></StyledWrapper> {/* Top div with vertical border */}
        </StyledWrapper>

        <StyledWrapper {...verticalDelimiterStyles.middleDiv}>or</StyledWrapper> {/* Middle div with text */}

        <StyledWrapper {...verticalDelimiterStyles.topBottomDiv}>
          <StyledWrapper {...verticalDelimiterStyles.lineDiv}></StyledWrapper> {/* Bottom div with vertical border */}
        </StyledWrapper>
      </StyledWrapper>
    </> :
    <>
    </>
  );
};

const widgetModule: WidgetModule = {
  component: VerticalDelimiter,
  definition: {
    group: "Common",
    icon: "heading",
  },
};

export default widgetModule;
